import { Fragment } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, ChevronDownIcon } from '@heroicons/react/20/solid'

const services = [
  { id: 1, name: 'Roof installation' },
  { id: 2, name: 'Roof replacement' },
  { id: 3, name: 'Roof repair' },
  { id: 4, name: 'Roof inspection' },
  { id: 5, name: 'Gutter cleaning' },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function CustomSelectBox({ label, formik }) {
  const handleChange = (selectedService) => {
    // Set the value of the "serviceName" field in Formik
    formik.setFieldValue('serviceName', selectedService.name)
  }

  return (
    <Listbox value={formik.values.serviceName} onChange={handleChange}>
      {({ open }) => (
        <>
          <Listbox.Label className="block font-heading text-sm font-medium leading-6 text-body">
            {label}
          </Listbox.Label>
          <div className="relative mt-2">
            <Listbox.Button className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-body shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-white-dark sm:text-sm sm:leading-6">
              <span className="block truncate">
                {formik.values.serviceName || 'Select a service'}
              </span>
              <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                <ChevronDownIcon
                  className="h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
              </span>
            </Listbox.Button>

            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                {services.map((service) => (
                  <Listbox.Option
                    key={service.id}
                    className={({ active }) =>
                      classNames(
                        active ? 'bg-white-dark text-white' : 'text-body',
                        'relative cursor-default select-none py-2 pl-3 pr-9'
                      )
                    }
                    value={service}
                  >
                    {({ selected, active }) => (
                      <>
                        <span
                          className={classNames(
                            selected ? 'font-semibold' : 'font-normal',
                            'block truncate'
                          )}
                        >
                          {service?.name}
                        </span>

                        {selected ? (
                          <span
                            className={classNames(
                              active ? 'text-white' : 'text-white-dark',
                              'absolute inset-y-0 right-0 flex items-center pr-4'
                            )}
                          >
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        </>
      )}
    </Listbox>
  )
}
